// events on load
$(window).ready(function() {
	openDropdown();
	modalVideoLaunch();
	ideaCardsCarousel();
	offerCardsCarousel();
	newsCardsCarousel();
	testimonialsCarousel();
	aboutCarousel();
	unhideIndexCategory(extraTrigger,extraContent,extraClass);
	micromodalInit();
	inViewport();
	dropdownPricingContent();
	toggleTab();
	toggleTabAccount();
	toggleAccordion();
	gradientHeightCheck();
	searchFilterFiltersForm();
	lazyYT();
	accountMainText();
	accountShowInfoTrigger();
	accountImages();
	accountSeeMoreTrigger();
	accountSeeMoreToggler();
	formMultimedia();
	triggerEditComment();
	openFancyBox();
	messageFrameToBottom();
	extraFields();
	defaultTextAlert();
	activationBtn();
	toTheTopInit();
});

// events on scroll
$(window).scroll(function() {
	fixedHeader();
	hidingTooltipsOnScroll();
});

// events on resize
window.onresize = function() {
};

// events on click
$(document).on("click", function(e) {
	dropdownClickContentClose(e);
	formMultimediaClose(e);
	accountMainTextClose(e);
});